import moment from 'moment';
import { useEffect } from 'react'
import { __OBJECT_STRUCTURE_GetDataserieValue } from '../../../common/ObjectStructures/sKPI';
import { getDataserieElementTag, getDataSerieValue } from '../../../services/sKPI/dataserie.service';
import { isNullUndefinedOrEmpty, isValidDate } from '../../../common/Helpers';



const  useGetDataSerieValue = (objDataSerieValue, setObjDataSerieValue, dataserieId, dataserieValueId, serieTime, isPanelOpen, fireGetEditElement, setFireGetEditElement) => {    
    useEffect(()=> {
        const getData = async () => {
            try {

                const ticks = moment(serieTime._d === undefined ? serieTime : serieTime._d).format('YYYYMMDDHHmmss');          

                let serviceResponse = await getDataSerieValue(dataserieId, dataserieValueId, ticks);
                const response = (serviceResponse.data.succeeded) ? serviceResponse.data.data : __OBJECT_STRUCTURE_GetDataserieValue(dataserieId);

                setFireGetEditElement && setFireGetEditElement(prevState => ({
                    ...prevState,               
                    fire : false,
                }))

                if (response.id === 0) {
                    try {
                        setObjDataSerieValue(prevState => ({
                            ...prevState,               
                            id : response.id,
                            dataserieId: dataserieId,
                            serieTime : moment(response.serieTime, 'YYYYMMDDHHmmss').toDate(),
                            wildcard : response.wildcard,
                            periodId : response.periodId,
    
                            valueGoal : response.valueGoal,
                            valueReal : response.valueReal,
                            valueProvisory : response.valueProvisory,
                            valueBudget : response.valueBudget,
                            valueForecast : response.valueForecast,
                            valueGoalPercent : response.valueGoalPercent,
                            variableObjetive : response.variableObjetive,
    
                            v1 : response.v1,
                            v2 : response.v2,
                            k1 : response.k1,
                            k2 : response.k2,
                            formula : response.formula,
                            formulaDesc : response.formulaDesc,
                            locked : response.locked,
                        }))
                    } catch (error) {
                        setObjDataSerieValue(prevState => ({
                            ...prevState,               
                            id : response.id,
                            dataserieId: dataserieId,
                            serieTime: response.serieTime !== null ? response.serieTime : serieTime,
                            wildcard : response.wildcard,
                            periodId : response.periodId,
    
                            valueGoal : response.valueGoal,
                            valueReal : response.valueReal,
                            valueProvisory : response.valueProvisory,
                            valueBudget : response.valueBudget,
                            valueForecast : response.valueForecast,
                            valueGoalPercent : response.valueGoalPercent,
                            variableObjetive : response.variableObjetive,
    
                            v1 : response.v1,
                            v2 : response.v2,
                            k1 : response.k1,
                            k2 : response.k2,
                            formula : response.formula,
                            formulaDesc : response.formulaDesc,
                            locked : response.locked,
                        }))
                    }
                }
                else {
                    setObjDataSerieValue(prevState => ({
                        ...prevState,               
                        id : response.id,
                        dataserieId: response.dataserieId,
                        wildcard : response.wildcard,
                        periodId : response.periodId,

                        valueGoal : response.valueGoal,
                        valueReal : response.valueReal,
                        valueProvisory : response.valueProvisory,
                        valueBudget : response.valueBudget,
                        valueForecast : response.valueForecast,
                        valueGoalPercent : response.valueGoalPercent,
                        variableObjetive : response.variableObjetive,

                        dd : response.dd,
                        mm : response.mm,
                        yyyy : response.yyyy,
                        serieTime : moment(response.serieTime, 'YYYYMMDDHHmmss').toDate(),
                        
                        v1 : response.v1,
                        v2 : response.v2,
                        k1 : response.k1,
                        k2 : response.k2,
                        formula : response.formula,
                        formulaDesc : response.formulaDesc,
                        
                        locked : response.locked,
                        closeProcessId : response.closeProcessId,
                    }))
                }
            }
            catch (error) {
            }
        }
        
        if (dataserieId !== null && serieTime !== null && isPanelOpen === true && fireGetEditElement) {
            getData()
        }
    }, [objDataSerieValue, setObjDataSerieValue, dataserieId, dataserieValueId, serieTime, isPanelOpen, fireGetEditElement, setFireGetEditElement]);
}

const  useGetDataserieTag = (dataserieId, tagItemsArray, setTagItemsArray, tagItems, setTagItems) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getDataserieElementTag(dataserieId);
                const response = (serviceResponse.data.succeeded) ? serviceResponse.data.data : [];
                setTagItems(response)
                setTagItemsArray(!isNullUndefinedOrEmpty(response.tags) ? response.tags.split(';') : [])
            }
            catch (error) {
                setTagItems({dataserieId: 0, tags: ''})
                setTagItemsArray([])
            }
        }
        
        if (dataserieId !== null && tagItems === null && tagItemsArray === null) {
            getData()
        }
    }, [dataserieId, tagItemsArray, setTagItemsArray, tagItems, setTagItems]);
}



export {
    useGetDataSerieValue,
    useGetDataserieTag
}